import { isEmptyString } from '../../util/object';
import { isNotNumber } from '../../util/numbers';

export default class CanvasImageBitmapInterface {
  /** @property {String} */
  _mediaIdentifier = null;

  /** @property {number} */
  _frameNumber = null;

  /** @property {HTMLCanvasElement} */
  _imageBitmap = null;

  /** @property {String} */
  static identifier = 'CanvasImageBitmap';

  constructor(mediaIdentifier, frameNumber, imageBitmap) {
    if (
      isEmptyString(mediaIdentifier) ||
      isNotNumber(frameNumber) ||
      !(imageBitmap instanceof HTMLCanvasElement)
    ) {
      throw new Error(
        `${CanvasImageBitmapInterface.name} was not initialized with correct params`,
      );
    }
    this._mediaIdentifier = mediaIdentifier;
    this._frameNumber = frameNumber;
    this._imageBitmap = imageBitmap;
  }

  get mediaIdentifier() {
    return this._mediaIdentifier;
  }
  get frameNumber() {
    return this._frameNumber;
  }
  get imageBitmap() {
    return this._imageBitmap;
  }
}
